/**
 * `/search` — the catalogue's own results surface, on this host.
 *
 * One `RouteObject`, so the file is `search.route.tsx` (singular).
 *
 * No `loader`, and no data read here: the URL's facets are the page's state and
 * the page component owns its reads, so there is one cache and one
 * invalidation story. A loader that fetched would build a second cache the
 * query client does not know about, and the two would drift on the second visit.
 */
import type { RouteObject } from 'react-router-dom';

export const searchRoute: RouteObject = {
  path: 'search',
  lazy: async () => {
    const { SearchPage } = await import('./SearchPage');
    return { Component: SearchPage };
  },
};
